export const RootScopeEvents = {
    ANALYTICS: {
        MEETING_HISTORY: 'analytics:meetingHistory',
        MEETING_HISTORY_EXPORT: 'analytics:exportMeetingHistory',
        USAGE: 'analytics:open',
        FILTER: 'analytics:filter',
    },
    CHAT: {
        ON_MESSAGE: 'chat:onMessage',
        ON_UPDATE_PERSON: 'chat:onUpdatePerson',
    },
    COMMUNICATION_CONTROL: {
        PHONE_START: 'communicationControl:phoneStart',
        PHONE_STOP: 'communicationControl:phoneStop',
        ANSWER_PHONE: 'communicationControl:answerPhone',
        DO_RESTART: 'communicationControl:doRestartCall',
    },
    PHONE: {
        STARTED: 'phone:started',
        START: 'phone:start',
    },
    SUBSCRIBER: {
        PARTICIPANT_VIDEO_APPEARED: 'participantVideoAppeared',
        CREATED: 'otSubscriberCreated',
        DESTROYED: 'otSubscriberDestroyed',
    },
    ACTIVE_PROVIDER: {
        CREATE_CHANNEL_ERROR: 'activeProvider:createChannel:error',
        CREATE_SESSION_ERROR: 'activeProvider:createSession:error',
        JOIN_SESSION_ERROR: 'activeProvider:joinSession:error',
        JOIN_SESSION_SUCCESS: 'activeProvider:joinSession:success',
        CONNECTION_CREATED: 'activeProvider:connectionCreated',
        CONNECTION_DESTROYED: 'activeProvider:connectionDestroyed',
        CONNECTION_WAITING_RECONNECT: 'activeProvider:connectionWatingToReconnect',
        CONNECTION_DESTROY_BY_TIMEOUT: 'activeProvider:connectionDestroyByTimeout',
        REPUBLISH_ON_ERROR: 'activeProvider:republishOnError',
        REPUBLISH_ON_WARNING: 'activeProvider:republishOnWarning',
        RECONNECTING_START: 'activeProvider:reconnectingStart',
        RECONNECTING_ERROR: 'activeProvider:reconnectingError',
        RECONNECTING_SUCCESS: 'activeProvider:reconnectingSuccess',
        RECONNECTING_SUCCESS_AFTER_TIMEOUT: 'activeProvider:reconnectingSuccessAfterTimeout',
        PERSON_RECONNECTED_SUCCESSFULLY: 'activeProvider:personReconnectedSuccessfully',
        FIRST_PARTICIPANT_APPEARED: 'activeProvider:firstParticipantAppeared',
        SESSION_CONNECTED: 'activeProvider:sessionConnected',
        SESSION_DISCONNECTED: 'activeProvider:sessionDisconnected',
        PUBLISHER_ERROR: 'activeProvider:publisherError',
        PUBLISHER_SUCCESS: 'activeProvider:publisherSuccess',
        END_REASON: 'activeProvider:endReason',
        AUDIO_TYPE_CHANGED: 'activeProvider:audioTypeChanged',
        DOWNGRADE_TO_AUDIO_ONLY: 'activeProvider:downgradeToAudioOnly',
        SCREEN_SHARE_STARTED: 'activeProvider:otScreenShareStarted',
        AUTO_DISABLE_MEDIA: 'activeProvider:autoDisableMedia',
        TOGGLE_MEDIA: 'activeProvider:toggleMedia',
        RECREATE_STREAM: 'activeProvider:recreateStream',
        OT_EXCEPTION: 'activeProvider:otException',
        STOP_NO_STREAM_CONNECTION: 'activeProvider:stopWhenNoConnectionForTheStream',
        IGNORE_ERROR: 'activeProvider:ignoreError',
        IGNORE_WARNING: 'activeProvider:ignoreWarning',
    },
    SESSION: {
        PUBLISHER_CREATED: 'session:publisherCreated',
        PUBLISHER_DESTROYED: 'session:publisherDestroyed',
        PUBLISHER_STREAM_CREATED: 'session:publisherStreamCreated',
    },
    CHANGE_VIDEO_QUALITY: 'changeVideoQuality',
    CHANGE_AUDIO_TYPE: 'changeAudioType',
    VIDEO_CHAT_LOADING_SCREEN: {
        UPDATE_MESSAGE: 'video-chat-loading-screen:update-message',
    },
    VIDEO_CHAT: {
        USER_CALL_RATING: 'videoChat:userCallRating',
    },
    REALTIME: {
        ERROR: 'realtime:error',
        INIT: 'realtime:init',
        SUBSCRIBE: 'realtime:subscribe',
    },
    STREAM: {
        CREATED: 'stream:created',
        VIDEO_ELEMENT_CREATED: 'stream:videoElementCreated',
        SUBSCRIPTION_ERROR: 'stream:subscriptionError',
        UNMUTE_VIDEO_EL: 'stream:unmuteVideoEl',
    },
    GROUP_CALL: {
        MAX_REACHED: 'maxReached',
    },
    OT_PUBLISHER_ERROR: 'otPublisherError',
    USER_ACTIONS: {
        FLIP_CAMERA: 'userActions:flipCamera',
        CHANGE_MIC: 'userActions:changeMic',
        CHANGE_CAMERA: 'userActions:changeCamera',
        CHANGE_SPEAKER: 'userActions:changeSpeaker',
        MUTE: 'userActions:mute',
        UNMUTE: 'userActions:unmute',
        VIDEO_DISABLED: 'userActions:videoDisabled',
        VIDEO_ENABLED: 'userActions:videoEnabled',
        GALLERY_VIEW_ENABLED: 'userActions:galleyViewEnabled',
        DEFAULT_VIEW_ENABLED: 'userActions:defaultViewEnabled',
        SHOW_PREVIEW: 'userActions:showPreview',
        HIDE_PREVIEW: 'userActions:hidePreview',
        OPEN_VIDEO_SETTINGS: 'userActions:openVideoSettings',
        OPEN_TROUBLESHOOTING: 'userActions:openTroubleshooting',
        OPEN_CALL_MENU: 'userActions:openCallMenu',
        PIN: 'userActions:pin',
        UNPIN: 'userActions:unpin',
    },
    PICTURE_IN_PICTURE: {
        START: 'pictureInPicture:start',
    },
    MARKETPLACE: {
        CLOSED: 'marketplace:closed',
        EXTENSION_VIEWED: 'marketplace:extensionViewed',
        EXTENSION_VOTED: 'marketplace:extensionVoted',
        EXTENSION_CLOSED: 'marketplace:extensionClosed',
    },
    AUTHENTICATION: {
        SIGN_IN_FORM_SUBMITTED: 'authentication.signInFormSubmitted',
        SIGN_UP_FORM_SUBMITTED: 'authentication.signUpFormSubmitted',
    },
    PAYMENT: {
        FINISHED: 'payment:finished',
    },
    FILE_TRANSFER: {
        FINISHED: 'fileTransfer:finished',
    },
    PATIENT_TRANSFER: {
        STARTED: 'patientTransfer:started',
        COMPLETED: 'patientTransfer:completed',
    },
    PATIENT_QUEUE: {
        DUPLICATES: 'patientTransfer:duplicates',
    },
    ACCOUNT_SETTINGS: {
        SHARING_PAGE_VISIT: 'sharingPageVisit',
    },
    CURRENT_USER_UPDATED: 'currentUserUpdated',
    CHECK_IN_SUCCESS: 'checkInSuccess',
    DOKBOT: {
        DOXYBOT_PRECALL_TEST_CANCEL: 'DoxybotPrecallTest:cancel',
    },
    MEDIA_BROKEN: 'mediaBroken',
    CLINIC_SETTINGS: {
        RESEND_INVITE: 'clinicSettings:resendInvite',
        CREATE_SHARED_ROOM_MODAL_CLICKED: 'clinicSettings:createSharedRoomClicked',
    },
    LEAVE_POPUP_COUNT: 'leave_popup_count',
    REMOVE_CURRENT_PATIENT_FROM_WAITING_ROOM: 'removeCurrentPatientFromWaitingRoom',
    DEVICE: {
        CHANGE_VIDEO_DEVICE: 'changeVideoDevice',
        CHANGE_AUDIO_DEVICE: 'changeAudioDevice',
    },
    GLOBAL_UI: {
        SCREEN_SHARING_UPDATED: 'globalUi:screenSharingUpdated',
    },
    INTERCOM: {
        SHOW: 'intercom:show',
        HIDE: 'intercom:hide',
        UNREAD_COUNT_CHANGE: 'intercom:unreadCountChange',
    },
    CLOSED_CAPTIONS: {
        USED: 'closedCaptionsUsed',
        STOPPED: 'closedCaptionsStopped',
        ERROR_STOPPING: 'closedCaptionsErrorStopping',
        DOCTOR_TOGGLED: 'closedCaptionsDoctorToggled',
        FAIL_START_VIA_REALTIME_SIGNALING: 'closedCaptionsFailStartViaRealtimeSignaling',
        FAIL_SELF_CAPTION_CREATION: 'closedCaptionsFailSelfCaption',
        FAIL_SELF_CAPTION_SUBSCRIPTION: 'closedCaptionsFailSelfCaptionSubscription',
        SELF_CAPTION_DESTROYED: 'closedCaptionsSelfCaptionDestroyed',
        FAIL_TO_SUBSCRIBE: 'closedCaptionsFailToSubscribe',
    },
};
